export const SET_RAW_VEHICLE_DATA = 'SET_RAW_VEHICLE_DATA'
export const SET_PAGINATION_DATA = 'SET_PAGINATION_DATA'
export const SET_PAGE = 'SET_PAGE'
export const APPEND_RAW_VEHICLE_DATA = 'APPEND_RAW_VEHICLE_DATA'
export const RESET_STATE = 'RESET_STATE'
